<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Company list"
          text=""
          class="elevation-1"
        >
          <v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="upsertDialog()"
            v-if="$can('upsert', 'company')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-data-table
            id="company_dataTable"
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon
                  >
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-text-field
                      clearable
                      md4
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                    ></v-autocomplete>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>
                  <b>
                    <a style="color:black" @click.prevent="upsertDialog(item)">{{ item.name }} {{ item.surname }}</a>
                  </b>
                </td>

                <td class="text-xs-right">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertDialog(item)">
                        <v-icon v-if="$can('upsert', 'company')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'company')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>Company details</span>
                  </v-tooltip>

                  <v-tooltip top v-if="$can('delete', 'company')">
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="companyItem = item; deleteDialog = true" class="ml-2">
                        <v-icon v-if="$can('delete', 'company')" v-on="on" color="primary">mdi-delete-forever</v-icon>
                      </a>
                    </template>
                    <span>Remove Company</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                  </v-tooltip>

                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <safety-company-upsert-modal v-model="companyDialog" :item="companyItem"/>
    <safety-delete-modal v-model="deleteDialog" entity="Company" :entityId="companyItem.name" @confirm="confirmDelete"/>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="company" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>
  </v-container>
</template>


<script>
import { getList, remove } from "@/api/company";
import { normalizeFilters } from "@/utils/filters";

export default {
  data() {
    return {
      companyItem: {},
      companyDialog: false,
      deleteDialog: false,
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "id",
        descending: true
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      rowsPerPageItems: [5,10,25],
      loading: true,
      items: [],
      totalItems: 0,
      headers: [
        { text: "Name", align: "left", value: "name" },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      filters: {
        name: {
          type:'text',
          value: undefined,
          replace: "VALUE%",
          placeholder: 'Search'
        },
      }
    };
  },
  computed: {
    
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", true);
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
        if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        this.getData();
      },
      deep: true
    }
  },
  mounted() {
    this.getData();
    this.$root.$on('updateCompanies', () => {
      this.getData();
    });
  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;
      const filters = JSON.parse(JSON.stringify(this.filters));
      getList(normalizeFilters(filters), this.pagination).then(data => {
        this.items = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalItems = data.tot;
        this.loading = false;
      });
    },
    changeSort(column) {
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = false;
      }
      this.pagination = oldPagination;
    },
    upsertDialog(item = {}) {
      this.companyItem = JSON.parse(JSON.stringify(item));
      this.companyDialog = true;
    },
    confirmDelete() {
      remove(this.companyItem.id).then( id => {
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Company deleted successfully",
          color: "success"
        });
      }).catch( errorData => {
        let message = errorData.response.data.message;
        if (message.search("foreign key constraint") ) {
           message = "This record has already been used and cannot be removed";
        }
        this.$store.dispatch("app/openSnackbar", {
          message: "Company Delete error : " +  message,
          color: "error"
        });
      });
    }

  }
};
</script>

<style lang="scss">
#company_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
}
</style>